import React,{ useEffect ,useState } from 'react'
import style from './NotificationPermissionHandler.module.css'
import {TiWarningOutline} from 'react-icons/ti'

function NotificationPermissionHandler() {
const [notificationIsAllowed, setNotificationIsAllowed] = useState(false);

const isSupported = () =>
'Notification' in window &&
'serviceWorker' in navigator &&
'PushManager' in window

    useEffect(() => {
      if (isSupported()) {
        if (Notification.permission === 'granted')  setNotificationIsAllowed(true)
        else setNotificationIsAllowed(false)

        console.log('notification permission',Notification.permission)}
    }, [isSupported()? Notification.permission:''
    ]);
  return (
    <div>
        {!notificationIsAllowed && 
        
        
        <div className={style.NotificationAllowedContainer}><h4>Notification permission is denied <TiWarningOutline/></h4>
        <h6>
           Kindly  <u>allow</u> notifications for Questa in your settings, to get notified when a teacher answers your question
           </h6></div> }
    </div>
  )
}

export default NotificationPermissionHandler